export interface AccessGroupsAssetsPatchState {
  isLoading: boolean;
  isCompleted: boolean;
  failedLastAccessGroupAssetsIds: string[];
  successAddedAssetsIds: string[];
  successDeletedAssetsIds: string[];
  pendingDeleteAssetsIds: string[];
  pendingAddAssetsIds: string[];
  errors: string[];
}

export const defaultState: AccessGroupsAssetsPatchState = {
  isLoading: false,
  isCompleted: false,
  failedLastAccessGroupAssetsIds: [],
  successAddedAssetsIds: [],
  successDeletedAssetsIds: [],
  pendingDeleteAssetsIds: [],
  pendingAddAssetsIds: [],
  errors: [],
};
